<template>
    <div class="c-translator-selector__section margin-t-32">

        <c-search @input="searching" :placeholder="'Zoeken op naam..'"></c-search>

        <template v-if="isSearching == false">
            <div class="c-translator-selector">
                    <h4>Top 5 {{type | lower}}</h4>
                    <c-table
                        v-if="topranked.length > 0"
                        :translators="topranked"
                        :max="max"
                        v-model="selection">
                    </c-table>
                    <p v-if="topranked.length == 0">Er zijn geen geschikte {{type | lower}} gevonden</p>
            </div>
        </template>

        <div class="c-translator-selector" v-if="isSearching == true || translators.length > 5">
            <h4 v-if="isSearching == false && translators.length > 5">Andere opties</h4>
            <h4 v-else-if="isSearching">Zoekresultaten</h4>

            <c-table
                :translators="others"
                :max="max"
                v-model="selection"></c-table>
        </div>
    </div>
</template>

<script>
import CTable from '@components/form/translators/Table';
import CSearch from '@components/table/Search';

export default {
    components: { CTable, CSearch },
    props: {
        translators: {
            type: Array,
            default: () => []
        },
        value: {
            type: Array,
            default: () => []
        },
        max: {
            type: Number,
            default: 1
        },
        type: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            search: '',
            selection: []
        }
    },
    methods: {
        clear() {
            this.search = '';
            this.selection = [];
        },
        searching(value) {
            this.search = value;
        }
    },
    watch: {
        selection() {
            this.$emit('input', this.selection);
        },
        value() {
            this.selection = this.value;
        }
    },
    computed: {
        isSearching() {
            return this.search !== '';
        },
        topranked() {
            return this.translators.slice(0,5);
        },
        others() {
            return ( this.isSearching ) ?
                this.translators.filter( t => t.opdrachtnemer.user.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ) :
                this.translators.slice(5);
        }
    },
    created() {
        this.selection = this.value;
    }
}
</script>
